import { useState } from "react";
import { clearDevAccount } from "../lib/client";

interface DevAuthStatusProps {
  userId: string;
}

/** Small banner shown when dev-auth mode is active, with a way to switch users. */
export function DevAuthStatus({ userId }: DevAuthStatusProps) {
  const [switching, setSwitching] = useState(false);

  async function switchUser() {
    setSwitching(true);
    try {
      await clearDevAccount();
    } finally {
      window.location.reload();
    }
  }

  return (
    <div className="banner dev-auth-banner">
      <span>
        🛠 Developer auth: <code>{userId}</code>
      </span>
      <button
        type="button"
        className="link-btn"
        onClick={switchUser}
        disabled={switching}
      >
        Switch user
      </button>
    </div>
  );
}
